import { render, staticRenderFns } from "./PassengerImportDetails.vue?vue&type=template&id=79b8b273&scoped=true"
import script from "./PassengerImportDetails.vue?vue&type=script&lang=js"
export * from "./PassengerImportDetails.vue?vue&type=script&lang=js"
import style0 from "./PassengerImportDetails.vue?vue&type=style&index=0&id=79b8b273&prod&lang=css"
import style1 from "./PassengerImportDetails.vue?vue&type=style&index=1&id=79b8b273&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b8b273",
  null
  
)

export default component.exports